export enum CampaignStatus {
  Created = 'Created',
  MarketingPlanGenerating = 'Marketing_plan_generating',
  MarketingPlanGenerated = 'Marketing_plan_generated',
  MarketingPlanConfirmed = 'Marketing_plan_confirmed',
  UnderMatchmaking = 'Under_matchmaking',
  MatchmakingCompleted = 'Matchmaking_completed',
  UnderDelivery = 'Under_delivery',
  Completed = 'Completed',
  Cancelled = 'Cancelled'
}

export enum AdsCampaignMarketingStrategy {
  INFLUENCER_MARKETING = 'influencer_marketing',
  AFFILIATES_MARKETING = 'affiliates_marketing',
  SALES_OUTREACH = 'sales_outreach'
}

export enum CampaignBriefVisibility {
  OnInvitation = 'on_invitation',
  AfterConfirmation = 'after_confirmation'
}
